export default __webpack_public_path__ + "static/media/tool_item_3_m.3fa93325.png";